import { types } from '../types';
import jwt_decode from 'jwt-decode';

const initialState = {
    geolocation: '',
    token: '',
    exp: null,
    user: {},
    channelLog: '',
    expirationToken: false,
};

const decryptTokenExp = (token: any) => {
    const data: { exp: null } = jwt_decode(token) || null;

    let result = null;
    if (data?.exp) {
        result = new Date(data?.exp * 1000) || null;
    }
    return result;
};

export const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.authLogin:
            return {
                ...state,
                token: action.payload.token,
                exp: decryptTokenExp(action.payload.token),
                user: { ...action.payload.user },
                channelLog: action.payload.user.channel,
            };

        case types.authRefresh:
            return {
                ...state,
                token: action.payload.token,
                exp: decryptTokenExp(action.payload.token),
            };

        case types.validationToken:
            return {
                ...state,
                expirationToken: true,
            };

        case types.validationGeolocation:
            return {
                ...state,
                geolocation: action.payload,
            };

        case types.logoutLogin:
            return {
                initialState,
            };

        default:
            return state;
    }
};
